// generated from 16_888 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const campaignRetargetFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("campaign_retarget_filter"),
  comparison_key: z.enum([
    "8", // 10_439 (61.81%)
    "7", // 6_449 (38.19%)
  ]),
  // null: 9 (0.05%)
  display_name: z
    .enum([
      "opened email", // 4_466 (26.46%)
      "clicked email", // 4_296 (25.45%)
      "directly opened push notification", // 2_945 (17.45%)
      "opened email (other opens)", // 1_073 (6.36%)
      "clicked in-app message button 1", // 964 (5.71%)
      "clicked in-app message", // 795 (4.71%)
      "opened email (machine opens)", // 794 (4.70%)
      "clicked in-app message button 2", // 778 (4.61%)
      "viewed in-app message", // 420 (2.49%)
      "clicked content card", // 173 (1.02%)
      "viewed content card", // 51 (0.30%)
      "dismissed content card", // 50 (0.30%)
      "clicked shortened sms link", // 27 (0.16%)
      "clicked push notification button", // 24 (0.14%)
      "clicked push story page", // 13 (0.08%)
      "replied to sms", // 8 (0.05%)
      "clicked tracked WhatsApp link", // 1 (0.01%)
      "read WhatsApp message", // 1 (0.01%)
      // Not sampled, but offered by CampaignRetargetFilter.allowed_interactions
      // (feature flipper dependent; names from TRIGGER_ONLY_PAST_TENSE_DISPLAY_NAME_BY_INTERACTION).
      "viewed banner",
      "clicked banner",
      "dismissed banner",
      "clicked tracked LINE link",
      "clicked tracked KakaoTalk link",
    ])
    .nullable(),
  // undefined: 7_118 (42.15%), defined 9_770 (57.85%)
  raw_value: z
    .union([
      // string samples: 9_762 (99.92%)
      // format object-id: 9_754 (99.92%)
      z.string(),
      // object samples: 8 (0.08%)
      z.object({
        campaign_id: common.objectId,
        sms_keyword_id: common.objectId,
      }),
    ])
    .optional(),
  value: z.object({
    // undefined: 45 (0.27%), defined 16_843 (99.73%)
    // true 4_015 (23.84%), false 12_828 (76.16%)
    expired: z.boolean().optional(),
    id: z.union([
      // string samples: 16_880 (99.95%)
      // format object-id: 16_843 (99.78%)
      z.string(),
      // object samples: 8 (0.05%)
      z.object({
        campaign_id: common.objectId,
        sms_keyword_id: common.objectId,
      }),
    ]),
    // undefined: 16_843 (99.73%), defined 45 (0.27%)
    pre_filter_value: z
      .object({
        // true 35 (77.78%), false 10 (22.22%)
        expired: z.boolean(),
        id: common.objectId,
        value: z.string(),
      })
      .optional(),
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
